<template>
  <div class="footer">
    <div class="footer-content">
      <div class="footer-section">
        <h3>上海臻晅信息科技有限公司</h3>
        <p>我们专注于为教育行业提供专业的信息化解决方案，助力教育现代化发展。</p>
      </div>
      <div class="footer-section">
        <h3>联系我们</h3>
        <p><i class="el-icon-location"></i> 地址：上海市嘉定区德富路1090号宝龙广场5号楼502室</p>
        <p><i class="el-icon-phone"></i> 电话：13671549886</p>
        <p><i class="el-icon-message"></i> 邮箱：contact@schoolsoft.cn</p>
      </div>
      <div class="footer-section">
        <h3>关注我们</h3>
        <div class="social-links">
          <a href="#"><i class="el-icon-s-platform"></i></a>
          <a href="#"><i class="el-icon-s-promotion"></i></a>
          <a href="#"><i class="el-icon-s-marketing"></i></a>
        </div>
      </div>
    </div>
    <div class="copyright">
      <p>版权所有 © 2017 上海臻晅信息科技有限公司</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: #1f2937;
  color: #f9fafb;
  padding: 3rem 0 1rem;
}
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 0 20px;
}
.footer-section {
  width: 300px;
  margin-bottom: 2rem;
}
.footer-section h3 {
  margin-bottom: 1rem;
  color: #60a5fa;
}
.footer-section p {
  margin-bottom: 0.5rem;
  color: #9ca3af;
}
.social-links {
  display: flex;
  gap: 1rem;
}
.social-links a {
  color: #9ca3af;
  font-size: 1.5rem;
}
.social-links a:hover {
  color: #60a5fa;
}
.copyright {
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid #4b5563;
  margin-top: 2rem;
  color: #9ca3af;
}
</style>
